import React, { useState, useEffect } from "react";
import GlobalStudentAwardsList from "../../../pages/common/globalstudentawardlist"
import { useAuth } from "../../../../usercontext";

export default function Awardslist({ slug, show }) {
  const { profile, setProfile } = useAuth();
  console.log("slug: ", slug, "Id: ", profile.id)
  return (
      <GlobalStudentAwardsList slug={slug} isStudent={false} show={show} />
  );
}
